export const keys = (t) => ({
	shortcuts: {
		a: t('gameRules.keyboard_shortcuts.a'),
		space: t('gameRules.keyboard_shortcuts.space'),
		b: t('gameRules.keyboard_shortcuts.b'),
		q: t('gameRules.keyboard_shortcuts.q'),
		d: t('gameRules.keyboard_shortcuts.d'),
		s: t('gameRules.keyboard_shortcuts.s'),
		i: t('gameRules.keyboard_shortcuts.i'),
		esc: t('gameRules.keyboard_shortcuts.esc'),
		f: t('gameRules.keyboard_shortcuts.f'),
		arrows: t('gameRules.keyboard_shortcuts.arrows'),
		m: t('gameRules.keyboard_shortcuts.m')
	}
});
